import React from "react";
import Button from "../Button/Button";
const classes = require("./BottomNav.module.scss");

const BottomNav = (props: { location: any }) => {
    let nextPath =
        props.location.pathname === "/about" ? "/projects" : "/about";
    return (
        <div className={classes.navContainer}>
            <div className={classes.mobileNavigation}>
                <Button label="Home" path="/" />
                <Button label="Next" path={nextPath} />
            </div>
        </div>
    );
};

export default BottomNav;
